var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12C2.75 6.88942 6.88942 2.75 12 2.75C17.1106 2.75 21.25 6.88941 21.25 12C21.25 17.1106 17.1106 21.25 12 21.25C11.5858 21.25 11.25 21.5858 11.25 22C11.25 22.4142 11.5858 22.75 12 22.75C17.939 22.75 22.75 17.939 22.75 12C22.75 6.06099 17.939 1.25 12 1.25C6.06099 1.25 1.25 6.06099 1.25 12C1.25 13.3045 1.45947 14.4843 1.77737 15.5481C1.85896 15.8211 2.0882 16.0243 2.36902 16.0725C2.64985 16.1207 2.93374 16.0057 3.10174 15.7755L5.93911 11.8886C6.18333 11.554 6.11009 11.0848 5.77553 10.8406C5.44097 10.5964 4.97178 10.6696 4.72756 11.0042L2.86481 13.556C2.79126 13.0602 2.75 12.5421 2.75 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 14.9904C13.7143 14.4968 14.0197 14.0629 14.4252 13.771C15.3824 13.0819 16 11.9947 16 10.7715C16 8.68857 14.2091 7 12 7C9.79086 7 8 8.68857 8 10.7715C8 11.9947 8.61757 13.0819 9.57476 13.771C9.98026 14.0629 10.2857 14.4968 10.2857 14.9904C10.2857 15.3385 10.5732 15.6207 10.9278 15.6207H13.0722C13.4268 15.6207 13.7143 15.3385 13.7143 14.9904Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1574 17.3131C10.1574 16.9338 10.4707 16.6262 10.8571 16.6262H13.1429C13.5293 16.6262 13.8426 16.9338 13.8426 17.3131C13.8426 17.6925 13.5293 18 13.1429 18H10.8571C10.4707 18 10.1574 17.6925 10.1574 17.3131Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaReload);
export default __webpack_public_path__ + "static/media/idea-reload.5a39ba7ff80acbaa696b869a4c1f3f0a.svg";
export { ForwardRef as ReactComponent };